import { memo, Fragment, useMemo  } from 'react'
import { fetchPostAdEvent, SchemaOholoMaterialShow } from 'api'
import { CmsGridWrapper } from 'commonStyledComponents'
import { AdImage } from 'component/AreaBox/Styled'
import VideoLargeBox from 'component/VideoLargeBox'
import { AdvertisementType } from 'constant/advertisement'
import { useSelector } from 'react-redux'
import { selectAdInfo } from 'redux/selector/app'
import { formatDate } from 'utils/timeFormat'

const AD_EVERY_VIDEO = 4

interface Template2Props {
  videoData?: any[]
  trigger?: React.ReactNode
  currentLimit?: number
}

/**
 * 模板 ID: "2": 大圖
 * */
function Template2({ videoData, trigger, currentLimit }: Template2Props) {
  const adInfo = useSelector(selectAdInfo)

  /** 視頻櫥窗中廣告位 */
  const adAreaCenter = useMemo(() => {
    return adInfo?.[AdvertisementType.AreaCentral] ?? []
  }, [adInfo])

  const onAdItemClick = (ad: SchemaOholoMaterialShow) => {
    if (ad) {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: ad.id,
        material_name: ad.name,
        oholo_site_id: ad.site_type,
        oholoer_id: ad.oholoer_id,
        oholoer_link: ad.oholoer_link,
        oholoer_name: ad.oholoer_name,
      })
      window.open(ad?.link, '_blank')
    } else {
      console.warn('no ad assigned')
    }
  }
  return (
    <CmsGridWrapper>
      {videoData?.slice(0, currentLimit).map((item, i) => {
        const hasAd = adAreaCenter.length > 0 && i >= AD_EVERY_VIDEO && (i - AD_EVERY_VIDEO) % AD_EVERY_VIDEO === 0
        const adIndex = ((i - AD_EVERY_VIDEO) / AD_EVERY_VIDEO) % adAreaCenter.length
        const ad = adAreaCenter[adIndex]
        return (
          <Fragment key={i}>
            {hasAd && (
              <AdImage src={ad.icon_path} source="preview" aspectRatio={374 / 94} onClick={() => onAdItemClick(ad)} />
            )}
            <VideoLargeBox videoInfo={item} allowUnload />
          </Fragment>
        )
      })}
      {trigger}
    </CmsGridWrapper>
  )
}

// this indicate areaBox should hide bottom section until fully shown
;(Template2 as any).lazy = true

export default memo(Template2)
